const api = process.env.REACT_APP_PUBLIC_AUTH
const url = process.env.REACT_APP_PUBLIC_API

module.exports = global.config = {
    url: process.env.REACT_APP_PUBLIC_API,

    /**
     * Configuro tutti gli End-Point
     */
    api: {
        /**
         * No required token
         */
        login: url + "users/login/index",
        passwordRecovery: url + "users/login/passwordrecovery",
        passwordKeyCodeCheck: url + "users/login/keycodecheck",
        passwordReset: url + "users/login/passwordreset",
        register: url + "users/register/index",
        activeAccount: url + "users/register/active",



        getUsers: api + "get/users/index",
        getUser: api + "get/users/user", // richiede obbligatoriamente l'id per gestire la richiesta(user/id)
        profile: api + "get/users/profile" // ritorna i dati del profilo, recuperandoli dal token inviato
    },


    cors: process.env.REACT_APP_PUBLIC_CORS
}
